module.exports = __webpack_public_path__ + "img/453.2a60a75b.jpg";